import { render } from "./SubscriptionStatistics.vue?vue&type=template&id=58fecbda"
import script from "./SubscriptionStatistics.vue?vue&type=script&lang=js"
export * from "./SubscriptionStatistics.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__